import { Box, ButtonBase, Typography } from "@material-ui/core";
import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Chevron } from "@/components/Chevron";
import {
  LearningFailure,
  LearningStageCard,
  LearningStageContent,
  useLearningLayout,
} from "@/components/learning/LearningStageContent";
import { Loading } from "@/components/Loading";
import { LEARNING_STAGES, LearningStageId } from "@/constants/learning";
import { useDevice } from "@/hooks/useDevice";
import { useLearningProgress } from "@/hooks/useLearningProgress";
import { BaseTemplate } from "@/layouts/BaseTemplate";

export const LearningTopPage: FC = () => {
  const classes = useLearningLayout();
  const history = useHistory();
  const { isMobile } = useDevice();
  const { statusMap, loading, initialized, error, refetch } = useLearningProgress();
  const [selectedStageId, setSelectedStageId] = useState<LearningStageId>(LEARNING_STAGES[0].id);
  const stage = LEARNING_STAGES.find((item) => item.id === selectedStageId) ?? LEARNING_STAGES[0];
  const handleBack = () => history.replace("/mypage");
  useEffect(() => {
    if (!isMobile) return;
    const handlePop = (event: PopStateEvent) => {
      event.preventDefault();
      history.replace("/mypage");
    };
    window.addEventListener("popstate", handlePop);
    return () => window.removeEventListener("popstate", handlePop);
  }, [isMobile, history]);
  return (
    <BaseTemplate
      isDense
      isPcV2
      isBackGroundWhite={isMobile}
      headerTitle={isMobile ? "学ぶ" : undefined}
      onBack={isMobile ? handleBack : undefined}
    >
      <Box className={classes.page}>
        <Box className={classes.head}>
          {!isMobile && (
            <ButtonBase className={classes.back} onClick={handleBack}>
              <Chevron direction="back" />
              ホーム
            </ButtonBase>
          )}
          <Typography component="h1" className={classes.title}>
            不動産投資を学ぶ
          </Typography>
          <Typography className={classes.description}>3つの段階に分けた全23章です。1章5分ほどで読めます。</Typography>
        </Box>
        {loading || !initialized ? (
          <Loading />
        ) : error ? (
          <LearningFailure error={error} onRetry={refetch} />
        ) : (
          <Box className={classes.columns}>
            <Box className={classes.cards}>
              {LEARNING_STAGES.map((item) => (
                <LearningStageCard
                  key={item.id}
                  {...item}
                  selected={!isMobile ? item.id === selectedStageId : undefined}
                  total={item.articles.length}
                  completed={item.articles.filter((article) => statusMap[article.id]).length}
                  onClick={() => (isMobile ? history.push(`/learning/${item.id}`) : setSelectedStageId(item.id))}
                />
              ))}
            </Box>
            {!isMobile && (
              <LearningStageContent
                stage={stage}
                statusMap={statusMap}
                onOpenArticle={(article) =>
                  history.push({ pathname: `/learning/articles/${article.id}`, state: { fromStage: stage.id } })
                }
                onNextStage={(next) => setSelectedStageId(next.id)}
              />
            )}
          </Box>
        )}
      </Box>
    </BaseTemplate>
  );
};
